import { getEvacuationCitiesByPrefecture } from "@/api/opendata.api";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";

export function getMergedEvacuationCitiesByPrefecture(
  prefectureName: string,
  mapsMapType: string,
): Promise<PortalAdapterApi.ResponseGetTopArea> {
  return getEvacuationCitiesByPrefecture(prefectureName, mapsMapType);
}
